import { render, staticRenderFns } from "./overview_of_cooperation.vue?vue&type=template&id=000314a8&scoped=true"
import script from "./overview_of_cooperation.vue?vue&type=script&lang=js"
export * from "./overview_of_cooperation.vue?vue&type=script&lang=js"
import style0 from "./overview_of_cooperation.vue?vue&type=style&index=0&id=000314a8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000314a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('000314a8')) {
      api.createRecord('000314a8', component.options)
    } else {
      api.reload('000314a8', component.options)
    }
    module.hot.accept("./overview_of_cooperation.vue?vue&type=template&id=000314a8&scoped=true", function () {
      api.rerender('000314a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/customer_information/components/overview_of_cooperation/overview_of_cooperation.vue"
export default component.exports